import 'whatwg-fetch';

/* ::
  type EmailerPostBody {
    email: string,
    apps?: string
   };
*/

export default {
  send: (data /* :EmailerPostBody */) =>
    fetch('https://trustkit-analytics-emailer.appspot.com/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify(data),
    }),
  // .then(request => request.json()),
};



// WEBPACK FOOTER //
// ./src/util/emailer-server.js